import React from 'react';
import { Player, BigPlayButton } from 'video-react';
import moment from 'moment';
import loader from '../../assets/loader.svg';
import noView from '../../assets/no-view.svg';
import "video-react/dist/video-react.css";
import * as emojis from './emoji';
import {baseUrl} from '../url';

class Video extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            videoId: this.props.videoId,
            approvalsData: {},
            patientData: {},
            tTime: '',
            votData: {},
            feedback: {},
            response: false,
            action: '',
            buttonsDisabled: false,
            message: ''
        }
        this.handleApprove = this.handleApprove.bind(this);
        this.handleUnapprove = this.handleUnapprove.bind(this);
        this.submitAction = this.submitAction.bind(this);
        this.handleReplay = this.handleReplay.bind(this);
    }
    componentDidMount(){
        const id = this.state.videoId;
        const token = localStorage.getItem('access_token');

        fetch(`${baseUrl}/admin/vots/${id}`,{
            method: 'GET',
            headers: {
                'Authorization': token
            },
        })
        .then((response) => {
            const auth = response.headers.get('Authorization');
            localStorage.setItem('access_token', auth);
            return response.json();
        })
        .then((responseJson) => {
            this.setState({
                approvalsData: responseJson.data.approvals,
                patientData: responseJson.data.patient,
                tTime: responseJson.data.treatment_time,
                votData: responseJson.data.vot,
                feedback: responseJson.data.vot.feedback,
                response: true
            })
        })
    }
    submitAction(){
        const id = this.state.videoId;
        const token = localStorage.getItem('access_token');
        let retries = 0;
        fetch(`${baseUrl}/admin/vots/${id}`,{
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token,
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                'action': this.state.action
            })
        }) 
        .then((response) => response.json())
        .then((responseJson) => {
            this.setState({
                response: true,
                message: responseJson.message
            })
            if(responseJson.message === 'VOT updated.'){
                this.setState({
                    buttonsDisabled: true,
                })
            }
        })
        .catch((error)=>{
            if (error === 401 && retries < 1){
                localStorage.getItem('access_token')
                .then(value => {
                    fetch(`${baseUrl}/token/refresh`,{
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': value
                        }
                    }).then(response => {
                        retries += 1;
                        if(response.status === 200){
                            localStorage.setItem('access_token', response.headers.get('Authorization'));
                            this.handleSubmit();
                        }
                        else{
                            alert('something went wrong please try again later');
                        }
                    })
                })
            }
			else if (error instanceof TypeError){
				console.log(error);
			}
            else{
                alert('something went wrong please try again later');
            }
        })
    }
    handleApprove(){
        this.setState({
            action: 'approved',
            response: false
        },this.submitAction)
    }
    handleUnapprove(){
        this.setState({
            action: 'unapproved',
            response: false
        },this.submitAction)
    }
    handleReplay(){
        this.setState({
            action: ''
        })
    }
    render(){
        let token = localStorage.getItem("access_token"),
            withoutBearer = token.replace(/Bearer /, ''),
            // parsedToken = JSON.parse(withoutBearer),
            { patientData, tTime, votData, feedback} = this.state,
            feeling = feedback.feeling;
        const { video_url } = votData;

        const dateReceived = moment(tTime).format('dddd MMMM D, YYYY h:mmA')

        let caregiverApproval = this.state.approvalsData.caregiver;
        // let approval;
        // if (caregiverApproval === 'approved' || caregiverApproval === 'unapproved'){
        //     approval = true;
        // }else{
        //     approval = false;
        // }
        return(
            <div className="video-player">
                {
                    !this.state.response &&
                    <div className="loader">
                        <img src={loader} alt=""/>
                    </div>
                }
                {
                    this.state.response && !this.state.action &&
                    <div>
                        {
                            video_url && 
                            <Player fluid={false} width="100%" height={383}>
                                <source src={`${votData.video_url}?token=${withoutBearer}`} />
                                <BigPlayButton position="center" />
                            </Player>
                        }
                        {
                            !video_url && 
                            <div className="no-view">
                                <img src={noView} alt=""/>
                                <div>
                                    NO VIDEO CONTAINED YET
                                </div>
                            </div>
                        }
                        {/* <div className="dis-app-div">
                            <button className="reject" onClick={this.handleUnapprove} disabled={this.state.buttonsDisabled || approval}>Reject</button>
                            <button className="approve" onClick={this.handleApprove} disabled={this.state.buttonsDisabled || approval}>Approve</button>
                        </div> */}
                        <div className="video-caption">
                            <div>
                                <p className="name"><span>{patientData.name}</span> {patientData.alias}</p>
                                <p className="time"><span>on</span> {dateReceived}</p>
                                <p className={`status ${caregiverApproval}`}>
                                    {caregiverApproval === "approved" && 
                                        <i className="fa fa-check"></i>
                                    }
                                    {caregiverApproval === "unapproved" && 
                                        <i className="fa fa-times"></i>
                                    }
                                    {caregiverApproval === "unapproved" && 'VOT Rejected'}
                                    {caregiverApproval === "action_required" && 'Pending Approval'}
                                    {caregiverApproval === "approved" && 'VOT Approved'}
                                </p>
                            </div>
                            <div className="feedback-div">
                                <p className="feedback-title">Feedback from patient</p>
                                <p className="feedback"><img src={emojis[feeling]} alt=""/>{!feedback.comment? feeling : feedback.comment}</p>
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.action === 'approved' && this.state.response && this.state.message === 'VOT updated.' &&
                    <div>
                        <div className="check">
                            <div className="svg-div">
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                                    <circle className="path circle" fill="none" stroke="#14DA9E" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
                                    <polyline className="path check" fill="none" stroke="#14DA9E" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
                                </svg>
                            </div>
                            <p><small>VOT successfully approved</small></p>
                            <button onClick={this.handleReplay}>Watch Again</button>
                        </div>
                    </div>
                }
                {
                    this.state.action === 'unapproved' && this.state.response && this.state.message === 'VOT updated.' &&
                    <div>
                        <div className="check">
                            <div className="svg-div">
                                <svg className="reject" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                                    <circle className="path circle" fill="none" stroke="#D06079" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
                                    <line className="path line" fill="none" stroke="#D06079" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
                                    <line className="path line" fill="none" stroke="#D06079" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
                                </svg>
                            </div>
                            <p><small>VOT rejected</small></p>
                            <button onClick={this.handleReplay}>Watch Again</button>
                        </div>
                    </div>
                }
                {
                    this.state.action && this.state.response && this.state.message !== 'VOT updated.' &&
                    <div>
                        <div className="check">
                            <div className="svg-div">
                                <svg className="error" xmlns="http://www.w3.org/2000/svg" viewBox="11433 755 28.429 28.429">
                                    <g transform="translate(11433 755)">
                                        <path className="a" d="M14.214,0A14.214,14.214,0,1,0,28.429,14.214,14.228,14.228,0,0,0,14.214,0Zm0,26.892A12.679,12.679,0,1,1,26.892,14.214,12.635,12.635,0,0,1,14.214,26.892Zm0,0"/>
                                        <path className="a" d="M69.973,80.737A1.537,1.537,0,1,1,68.437,79.2a1.532,1.532,0,0,1,1.537,1.537Zm0,0" transform="translate(-58.868 -69.692)"/>
                                        <path className="a" d="M149.173,80.737a1.537,1.537,0,1,1-1.537-1.537,1.532,1.532,0,0,1,1.537,1.537Zm0,0" transform="translate(-128.56 -69.692)"/>
                                        <path className="a" d="M63.955,143.4a8.93,8.93,0,0,0-7.455,4.046l1.3.828a7.317,7.317,0,0,1,12.281,0l1.3-.828a8.929,8.929,0,0,0-6.4-3.986,7.492,7.492,0,0,0-1.02-.06Zm0,0" transform="translate(-49.717 -126.184)"/>
                                    </g>
                                </svg>
                            </div>
                            <p><small>Something went wrong, please try again later</small></p>
                            <button onClick={this.handleReplay}>Watch Again</button>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default Video;


// WEBPACK FOOTER //
// ./src/components/VideoPlayer/Video.js